<template>
  <de-layout-content>
    <div class="header" style="display: flex; align-items: center; justify-content: space-between;">
      <div>
        <div class="alnCt">
          <span class="name mr20">{{ info.name }}</span>
          <span v-if="info.approvalStatus == 1">
            <span style="color: #ff9900">●</span>&nbsp;待审批
          </span>
          <span v-if="info.approvalStatus == 2">
            <span style="color: #19be6b">●</span>&nbsp;审批通过
          </span>
          <span v-if="info.approvalStatus == 3">
            <span style="color: #f56c6c">●</span>&nbsp;审批不通过
          </span>
        </div>
        <div class="alnCt mt15">
          <span class="mr20">提交时间：{{ formatTime(info.createTime) }}</span>
          <span class="mr20" v-if="info.approvalStatus != 1">审批时间：{{ formatTime(info.approvalTime) }}</span>
          <span class="mr20" v-if="info.approvalStatus == 3">拒绝原因：{{ info.approvalDesc }}</span>
        </div>
      </div>
      <div class="alnCt" v-if="info.approvalStatus == 1">
        <a-button type="primary" icon="edit" @click="show = true"> 审批用户 </a-button>
      </div>
    </div>
    
    <!-- <a-card class="infoCard mt20" title="成员详情"> -->
    <div class="cyInfo">
      <div>
        <div class="alnCt ant-descriptions-title">
          <span style="color: #1890FF">▋</span>基本信息
        </div>
        <div class="alnCt mt20 descCont">
          <div class="avaCont">
            <a-avatar shape="square" :size="120" :src="info.headImageUrl" />
            <div class="typeTag mt10">{{ userTypeObj[info.type] }}</div>
          </div>
          <div class="flx1">
            <el-descriptions title="" :column="3" border>
              <el-descriptions-item label="姓名">{{ info.name || '-' }}</el-descriptions-item>
              <el-descriptions-item label="身高(cm)">{{ info.height || '-' }}</el-descriptions-item>
              <el-descriptions-item label="家庭地址">{{ info.addressName || '-' }}</el-descriptions-item>
              <el-descriptions-item label="体重(kg)">{{ info.weight || '-' }}</el-descriptions-item>
              <el-descriptions-item label="详细地址">{{ info.detailedAddress || '-' }}</el-descriptions-item>
              <el-descriptions-item label="性别">{{info.sex == 1 ? '男' : '女'}}</el-descriptions-item>
              <el-descriptions-item label="手机号码">{{ info.phone || '-' }}</el-descriptions-item>
              <el-descriptions-item label="所在机构">{{ info.employerName || '-' }}</el-descriptions-item>
              <el-descriptions-item label="生日">{{ info.birthday ? moment(info.birthday).format('YYYY-MM-DD') : '-' }}</el-descriptions-item>
              <el-descriptions-item label="身份证号码">{{ info.idCardNo || '-' }}</el-descriptions-item>
              <el-descriptions-item label="入队时间">{{ info.workingTime ? moment(info.workingTime).format('YYYY-MM-DD') : '-' }}</el-descriptions-item>
              <el-descriptions-item label="年龄">{{ info.age || '-' }}</el-descriptions-item>
              <el-descriptions-item label="邮箱">{{ info.email || '-' }}</el-descriptions-item>
              <el-descriptions-item label="训练项目">{{ info.trainingProject || '-' }}</el-descriptions-item>
            </el-descriptions>
          </div>
        </div>
      </div>

      <div class="mt20" v-if="type == 2">
        <div class="alnCt ant-descriptions-title">
          <span style="color: #1890FF">▋</span>个人成绩
        </div>
        <el-descriptions title="" :column="1" border  class="otherDesc">
          <el-descriptions-item label="运动员等级">{{info.achieves && info.achieves.length > 0 ? info.achieves[0].sportsLevelName : '-'}}</el-descriptions-item>
          <el-descriptions-item label="运动成绩">{{info.achieves && info.achieves.length > 0 ? info.achieves[0].sportPerformance : '-'}}</el-descriptions-item>
        </el-descriptions>
      </div>

      <div class="mt20" v-if="type != 2">
        <div class="alnCt ant-descriptions-title">
          <span style="color: #1890FF">▋</span>教育经历
        </div>
        <div class="mt20">
          <a-table bordered :pagination="false" :columns="jyColumns"
            :data-source="info.educations ? info.educations : []">
            <template v-slot:degree="{ record }">
              <div>{{ $filters.toIdListName(record.degree, educateData) }}</div>
            </template>
          </a-table>
        </div>
      </div>

      <div class="mt20" v-if="type != 2">
        <div class="alnCt ant-descriptions-title">
          <span style="color: #1890FF">▋</span>执教履历
        </div>
        <div class="mt20">
          <a-table bordered :pagination="false" :columns="zjColumns"
            :data-source="info.teaches ? info.teaches : []"></a-table>
        </div>
      </div>

      <div class="mt20">
        <div class="alnCt ant-descriptions-title">
          <span style="color: #1890FF">▋</span>其他信息
        </div>
        <el-descriptions title="" :column="1" border  class="otherDesc">
          <el-descriptions-item label="备注">{{info.remark || '无备注'}}</el-descriptions-item>
        </el-descriptions>
      </div>

      <div class="mt20">
        <div class="alnCt ant-descriptions-title">
          <span style="color: #1890FF">▋</span>操作记录
        </div>
        <div class="wz-pl-2">
          <a-empty v-if="operatingList.length <= 0" :image="simpleImage" />
          <div class="mt10" v-for="(item, index) in operatingList" :key="index">
            <a-badge color="#108ee9" :text="item.dayTxt" />
            <div class="mt10">
              <a-card>
                <div class="spcBt">
                  <div>
                    <a-avatar size="large" :src="item.headImageUrl">
                      <template #icon>
                        <UserOutlined />
                      </template>
                    </a-avatar>
                    <span class="ml10">{{ item.name }}</span>
                  </div>
                  <div>{{ item.timeTxt }}</div>
                </div>
                <div class="mt10">操作：{{ item.operatingType }}</div>
              </a-card>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="审批用户" inline="true" :visible.sync="show" width="600px">
      <el-form ref="editForm" :model="editForm" size="mini" :rules="rules" label-width="120px">
        <el-form-item label="审批结果:" prop="approvalStatus">
          <el-radio-group v-model="editForm.approvalStatus">
            <el-radio label="2">审批通过</el-radio>
            <el-radio label="3">审批不通过</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="选择组别:" class="isRequired" v-if="editForm.approvalStatus != 3">
          <el-form-item label="" prop="teamId" class="mr20">
            <el-select v-model="editForm.teamId" placeholder="所属运动队" @change="change">
              <el-option v-for="item in teamData" :key="item.id" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="groupId">
            <el-select v-model="editForm.groupId" placeholder="所属组别" @change="$forceUpdate()">
              <el-option v-for="item in groupData" :disabled="!editForm.teamId" :key="item.id" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form-item>

        <el-form-item label="填写原因:" prop="approvalDesc" v-else>
          <el-input :rows="4" type="textarea" maxlength="300" placeholder="请填写原因" show-word-limit
            v-model="editForm.approvalDesc" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="show = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </de-layout-content>
</template>

<script>
import moment from "moment";
import axios from 'axios'
import { message } from "ant-design-vue";
import * as API_Member from "@/api/train/member";

const jyColumns = [
  { title: "学校名称", dataIndex: "collegeName", key: "collegeName", align: 'center' },
  {
    title: "学历", dataIndex: "degree", key: "degree", align: 'center',
    slots: { customRender: "degree" },
  },
  { title: "专业", dataIndex: "major", key: "major", align: 'center' },
  {
    title: "教育时间", dataIndex: "educationTime", key: "educationTime", align: 'center',
    customRender: ({ text }) => {
      let date = text && text.split('-') || []
      return date.length ? `${moment(+date[0]).format("yyyy")}-${moment(+date[1]).format("yyyy")}` : ''
    },
  },
];
const zjColumns = [
  { title: "公司名称", dataIndex: "companyName", key: "companyName", align: 'center' },
  { title: "职位", dataIndex: "position", key: "position", align: 'center' },
  {
    title: "执教时间", dataIndex: "teachingTime", key: "teachingTime", align: 'center', customRender: ({ text }) => {
      let date = text && text.split('-') || []
      return date.length ? `${moment(+date[0]).format("yyyy/MM")}-${moment(+date[1]).format("yyyy/MM")}` : ''
    },
  },
  { title: "执教内容", dataIndex: "teachingContent", key: "teachingContent", align: 'center' },
];

export default {
  data() {
    return {
      id: null,
      info: {},
      citys: [],
      operatingList: [],
      userTypeObj: {
        1: "管理员",
        2: "运动员",
        3: "教练",
        4: "队医",
        5: "队伍管理者",
      },
      // 教育经历数据
      jyColumns: jyColumns,
      // 执教经历数据
      zjColumns: zjColumns,
      show: false,
      editForm: {
        teamId: null,
        groupId: null,
        approvalDesc: null,
        approvalStatus: null,
      },
      rules: {
        teamId: [{ required: true, message: "请选择所属运动队", trigger: "change" },],
        groupId: [{ required: true, message: "请选择所属组别", trigger: "change" },],
        approvalDesc: [{ required: true, message: "请填写拒绝原因", trigger: "blue" },],
        approvalStatus: [{ required: true, message: "请选择审批结果", trigger: "change" },],
      },
      teamData: [],
      groupData: [],
    };
  },
  computed: {
    // 模块显示
    showModule() {
      return (type) => {
        switch (type) {
          // 个人成绩
          case "achieves":
            return (
              [2].includes(this.userInfo.type) &&
              this.info[type] &&
              this.info[type].length
            );
          // 教育经历
          case "educations":
          // 执教履历
          case "teaches":
            return (
              [1, 3, 4].includes(this.userInfo.type) &&
              this.info[type] &&
              this.info[type].length
            );
          default:
            return false;
        }
      };
    },
    // 格式化时间
    formatTime() {
      return (time) => {
        return time && moment(time).format("yyyy-MM-DD HH:mm:ss");
      };
    },
    // 格式化日期
    formatDate() {
      return (time) => {
        return time && moment(time).format("MM-DD");
      };
    },
  },
  methods: {
    moment,
    getCitys() {
      let url = `administrativeArea.json`;
      axios.get(url, {}, false, true).then((res) => {
        console.log(res);
        this.citys = res.data || [];
        this.getInfo();
        this.getOperatingRecord();
      });
    },
    getInfo() {
      API_Member.memberInfo(this.id).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.info = res.data;
        }
      })
    },
    getOperatingRecord() {
      API_Member.operateRecord({ bizId: this.id, type: 1 }).then((res) => {
        console.log(res);
        if (res.code == 200) {
          res.data.forEach(item => {
            item.dayTxt = moment(item.createTime).format('YYYY-MM-DD')
            item.timeTxt = moment(item.createTime).format('YYYY-MM-DD HH:mm:ss')
          })
          this.operatingList = res.data;
        }
      })
    },
    // 获取运动队
    _getTeams() {
      API_Member.teamList().then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.teamData = res.data.map((item) => {
            return {
              value: item.id,
              label: item.name,
              key: item.id,
            };
          });
        }
      });
    },
    change(e) {
      console.log(e);
      this.editForm.groupId = null;
      this.groupData = [];
      this.getGroups(e);
    },
    // 获取运动组
    getGroups(teamId) {
      API_Member.groupList({ teamId }).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.groupData = res.data.map((item) => {
            return {
              value: item.id,
              label: item.name,
              key: item.id,
            };
          });
        }
      });
    },
    getCityById(code, arr = this.citys) {
      if (!code) {
        return ''
      }
      const findItem = arr.find((item) =>
        JSON.stringify(item).includes(`"code":"${code}"`)
      );
      if (!findItem) return '';
      else if (findItem.code == code) {
        return findItem.name;
      } else {
        return findItem.name + '/' + this.getCityById(code, findItem.areaList);
      }
    },
    cancel() {
      this.editForm = {
        teamId: null,
        groupId: null,
        approvalDesc: null,
        approvalStatus: null,
      }
    },
    approvalUser(params) {
      API_Member.memberAudit(params).then(res => {
        console.log(res);
        if (res.code == 200) {
          message.success("操作成功！");
          this.cancel(); // 清空表单
          this.show = false;
          this.getInfo();
        }
      })
    },
    submitForm() {
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          const params = {
            ids: [this.id],
            ...this.editForm,
          };
          this.approvalUser(params);
        } else {
          console.log("error submit!!");
          this.$message({
            message: "填写数据不全或数据有误",
            type: "error",
          });
          return false;
        }
      });
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
  },
  mounted() {
    this.getCitys();
    // 获取运动组数据
    this._getTeams();
  },
};
</script>
<style lang='less'>
@import "/src/styles/common/common.less";

.infoCard .ant-card-head-title {
  font-weight: bold;
}

.infoDesc.ant-descriptions-bordered.ant-descriptions-middle .ant-descriptions-item-label {
  width: 200px;
}
</style>
<style scoped lang="less">
.cyInfo {
  ::v-deep .el-descriptions__body {
    width: 100%;
    background-color: unset;
  }
  ::v-deep .el-descriptions {
    display: flex;
    .el-descriptions-item {
      flex: 1;
    }
    .el-descriptions-row {
      th {
        height: 60px;
        width: 150px;
        color: #BCBCBC;
        font-size: 14px;
        font-weight: bold;
        background-color: #21284b;
      }
      td {
        height: 60px;
        min-width: 200px;
        color: #fff;
        font-size: 12px;
        background-color: #141937;
      }
    }
  }
}
.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px;

  .name {
    font-size: 1.2em;
    font-weight: bold;
  }
}

:deep(.ant-descriptions-title) {
  margin-top: 20px !important;
}

.descCont {
  position: relative;
  padding-left: 330px;
}

.avaCont {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 330px;
  height: 100%;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-right: none;
  background-color: #141937;

  .typeTag {
    display: inline-flex;
    align-items: center;
    height: 28px;
    padding: 0 20px;
    border-radius: 14px;
    color: #fff;
    background-color: #FDA827;
  }
}
.dialog-footer{
  button{
    &:hover{
      background-color: #000 !important
    }
  }
}
</style>
